module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile":"Profile"},"fr":{"profile":"Profil"}}')
  delete Component.options._Ctor
}
